import { render, staticRenderFns } from "./BookingPassengersPriceDetails.vue?vue&type=template&id=4c0976ce&scoped=true"
import script from "./BookingPassengersPriceDetails.vue?vue&type=script&lang=js"
export * from "./BookingPassengersPriceDetails.vue?vue&type=script&lang=js"
import style0 from "./BookingPassengersPriceDetails.vue?vue&type=style&index=0&id=4c0976ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0976ce",
  null
  
)

export default component.exports